import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
export var CardBody = function (props) {
    return (React.createElement("div", { style: props.style, className: classNames('k-card-body', props.className) }, props.children));
};
CardBody.propTypes = {
    className: PropTypes.string
};
//# sourceMappingURL=CardBody.js.map